import { TURBO_STREAM_ACCEPT_HEADER } from "./constants";

export const originalResponseFromTurboResponseEvent = (event) => event.detail.fetchResponse.response;

export const fetchStream = (url) => {
  // Call a turbo-stream programmatically, similarly to how one would lazy-load a turbo-frame
  // See here for more context : https://github.com/hotwired/turbo/issues/34#issuecomment-821881266
  // The before/after events are fired in order to be able to hook into them if necessary
  // (they can probably be safely removed as those hooks are used when request are triggered automatically by turbo, which is exactly not the case here)
  document.dispatchEvent(beforeFetchRequestEvent());
  const promise = fetch(url, {
    headers: {
      Accept: TURBO_STREAM_ACCEPT_HEADER,
    },
  })
    .then(dispatchBeforeFetchResponseEvent)
    .then(breakOnServerError)
    .then((r) => r.text())
    .then((html) => Turbo.renderStreamMessage(html));

  return promise;
};

const beforeFetchRequestEvent = () => {
  // Necessary to comply with the Event spec: https://turbo.hotwired.dev/reference/events#turbo%3Abefore-fetch-request
  const event = new Event("turbo:before-fetch-request");
  event.detail = { fetchOptions: {} };
  return event;
};

const beforeFetchResponseEvent = (response) => {
  // Here we are trying to comply with the spec to make it work with our current usage, but this is clearly partially
  // meeting the requirements and may create subtle bugs if we start using FetchResponse getters
  const event = new Event("turbo:before-fetch-response");
  event.detail = { fetchResponse: { response: response } };
  return event;
};

const dispatchBeforeFetchResponseEvent = (response) => {
  document.dispatchEvent(beforeFetchResponseEvent(response));
  return response;
};

const breakOnServerError = (response) => {
  if (response.status > 499) {
    throw new Error("Server error");
  }

  return response;
};
